import { render, staticRenderFns } from "./ActivityTypeInTextBox.vue?vue&type=template&id=16055839&scoped=true"
import script from "./ActivityTypeInTextBox.vue?vue&type=script&lang=ts"
export * from "./ActivityTypeInTextBox.vue?vue&type=script&lang=ts"
import style0 from "./ActivityTypeInTextBox.vue?vue&type=style&index=0&id=16055839&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16055839",
  null
  
)

/* custom blocks */
import block0 from "./ActivityTypeInTextBox.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports